import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function HomePage({ language }) {
  const location = useLocation();

  return (
    <section className="home-note" aria-label="Field notes">
      <div className="home-note__card">
        <p className="home-note__kicker mono">FIELD NOTES</p>
        <h2>{language === 'ja' ? 'このページは準備中です' : 'This page is under construction'}</h2>
        <p>
          {language === 'ja'
            ? '今後は、制作背景や改善ログ、設計メモをこのページに追加予定です。現時点ではポートフォリオをご覧ください。'
            : 'This route will host design notes, implementation logs, and process updates. For now, please continue to the portfolio.'}
        </p>
        <Link to={{ pathname: '/', search: location.search }} className="button button--primary">
          {language === 'ja' ? 'ポートフォリオへ戻る' : 'Back to Portfolio'}
        </Link>
      </div>
    </section>
  );
}

export default HomePage;
